module.exports = new __parcel__URL__("troops_healer_small.f9a26303.png").toString();